import { render, staticRenderFns } from "./IncrementalRevenueCard.vue?vue&type=template&id=9923d1a6&scoped=true"
import script from "./IncrementalRevenueCard.vue?vue&type=script&lang=js"
export * from "./IncrementalRevenueCard.vue?vue&type=script&lang=js"
import style0 from "./IncrementalRevenueCard.vue?vue&type=style&index=0&id=9923d1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9923d1a6",
  null
  
)

export default component.exports